import { createSlice } from '@reduxjs/toolkit';

const postdocSlice = createSlice({
  name: 'postdoc', 
  initialState: {
    postdocData: null,
    postdocExists: false,
    isPostdocAdmin: false, 
  },
  reducers: {
    setPostdocData: (state, action) => { 
      state.postdocData = action.payload.postdocData;
      state.postdocExists = action.payload.postdocExists;
      state.isPostdocAdmin = action.payload.isPostdocAdmin;
    },
    resetPostdoc: (state) => { 
      state.postdocData = null;
      state.postdocExists = false;
      state.isPostdocAdmin = false;
    },
  },
});

export const { setPostdocData, resetPostdoc } = postdocSlice.actions;

export const selectPostdocData = (state) => state.postdoc.postdocData;
export const selectPostdocExists = (state) => state.postdoc.postdocExists;
export const selectIsPostdocAdmin = (state) => state.postdoc.isPostdocAdmin;

export default postdocSlice.reducer;
